/**
 * A form field's placeholder (design-system §5 *Form fields*, Rev 70 and its select / date rule): *Enter* and the
 * field's name for a field the person types into (*Company name* → *Enter company name*), *Select* and the
 * field's name for one they choose from — a select, a picker, a date (*Country* → *Select country*). Never an
 * example value: a format the person needs goes in the field's helper text.
 *
 * The name is the field's label as written, in sentence case, with its first letter lowered — unless the first
 * word is an acronym (*LKR price* → *Enter LKR price*), which keeps its capitals.
 */

/** The label as it reads inside a sentence: its first letter lowered, unless its first word is an acronym. */
export function labelInSentence(label: string): string {
    const trimmed = label.trim();
    const firstWord = trimmed.split(/\s/, 1)[0] ?? '';
    const acronym = firstWord.length > 1 && firstWord === firstWord.toUpperCase() && /[A-Z]/.test(firstWord);
    return acronym ? trimmed : trimmed.charAt(0).toLowerCase() + trimmed.slice(1);
}

/** *Enter <name>* — the placeholder of a field the person types into. */
export function enterPlaceholder(label: string): string {
    return `Enter ${labelInSentence(label)}`;
}

/** *Select <name>* — the placeholder of a select, picker or date field. */
export function selectPlaceholder(label: string): string {
    return `Select ${labelInSentence(label)}`;
}
